import React from 'react';
import PropTypes from 'prop-types';
import {Marker, Popup} from 'react-leaflet';
import L from 'leaflet';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
//import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

// Fixes https://github.com/Leaflet/Leaflet/issues/4968
L.Marker.prototype.options.icon = L.icon({
    iconRetinaUrl,
    iconUrl: '/app/images/marker.png',
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
});

export default class HousePOI extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        url: PropTypes.string,
        position: PropTypes.any,
        street: PropTypes.string,
        zip: PropTypes.string,
        city: PropTypes.string,
        showMapLink: PropTypes.bool,
        draggable: PropTypes.bool,
        onPositionChanged: PropTypes.func,
    }

    static defaultProps = {
        showMapLink: true,
        draggable: false,
    }

    static defaultPosition = [53.88573, 8.64584]
    static fallbackMapLink = 'https://www.google.com/maps/place/Cuxhaven,Deutschland'

    markerRef = React.createRef();

    eventHandlers = {
        dragend: () => {
            const marker = this.markerRef.current;
            if (marker != null && this.props.onPositionChanged) {
                this.props.onPositionChanged(marker.getLatLng());
            }
        },
    }

    componentDidUpdate() {
        if (this.markerRef.current) {
            this.markerRef.current.openPopup();
        }
    }

    render() {
        const {
            name,
            url,
            position,
            street,
            zip,
            city,
            showMapLink,
            draggable,
        } = this.props;
        const hasName = typeof name !== 'undefined';
        const hasUrl = typeof url !== 'undefined';
        const hasStreet = typeof street !== 'undefined';
        const hasZip = typeof zip !== 'undefined';
        const hasCity = typeof city !== 'undefined';
        const hasPosition = typeof position !== 'undefined';
        const hasAddress = hasStreet && hasCity && hasZip;
        const place = showMapLink &&
            ((hasAddress || hasPosition) ?
                    'https://www.google.com/maps/place/' +
                    (hasAddress ? street + ' ' + zip + ' ' + city + ', Deutschland/' : '') +
                    '@' + position.join(',') + ',16z' :
                    HousePOI.fallbackMapLink
            ) + '?hl=de-DE';
        return (
            <Marker
                position={position}
                draggable={draggable}
                eventHandlers={this.eventHandlers}
                ref={this.markerRef}
            >
                <Popup
                    autoPan={false}
                >
                    {hasName &&
                    <>
                        {(hasUrl ?
                            <a target="_blank" rel="noreferrer" href={url}>{name}</a> :
                            name
                        )}
                        <br/>
                    </>
                    }
                    {hasStreet && <> {street} <br/> </>}
                    {(hasCity || hasZip) && <> {(hasZip ? zip : '') + ' ' + (hasCity ? city : '')} <br/> </>}
                    {showMapLink &&
                        <a className="show-maps" href={place} target="_blank" rel="noreferrer">
                            In Google Maps anzeigen
                        </a>
                    }
                </Popup>
            </Marker>
        );
    }
}
